import { ActivityCardCol } from "./components/activityCardCol";
import React, { Component } from "react";
import "./dashboard.css";
import { Link } from "react-router-dom";
import {
  Row,
  Card,
  Col,
  Tabs,
  Table,
  Statistic,
  Icon,
  Input,
  DatePicker,
  Button,
  Drawer,
  Alert,
  Tag,
  message,
  Skeleton
} from "antd";
import Chart from "react-google-charts";
import Profile from "../profile/view";
import TopHeader from "../../components/topHeader/view";
import ActivityCard from "./components/activityCard";
import { connect } from "react-redux";
import Moment from 'react-moment';
import GenTableHR from './components/genTable/hackerRank';
import GenTableHE from './components/genTable/hackerEarth';
import GenTableGG from './components/genTable/geeksForGeeks';
import GenTableDB from './components/genTable/dashboard';
import * as loginActions from "./actions";

const { Column, ColumnGroup } = Table;
const { Search } = Input;
const { TabPane } = Tabs;

class cpDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentWillMount() {
    
    this.props.loadCpDashbaord();

  }

  render() {

    //const loading  = this.props.skeltonLoading ? this.props.skeltonLoading.show : true;
    const cpDashbaordData  =  this.props.cpDashbaordData ? this.props.cpDashbaordData : null
    
    const loading  = this.props.skeltonLoading ? this.props.skeltonLoading.show : true;
    
    return (
      <>
        <TopHeader title={"Competitive Programming"} />
        <Row gutter={16} style={{ padding: 25 }}>
          <Alert
            type="warning"
            style={{ marginBottom: 20 }}
            message={
              <>
                {" "}
                <Icon type="clock-circle" /> This Dashboard data last updated on{" "}
            {cpDashbaordData && <Moment unix>{cpDashbaordData.data.timestamp.seconds}</Moment>}{" "}
              </>
            }
          ></Alert>
          <ActivityCardCol data={cpDashbaordData ? cpDashbaordData.data.total : {}} />
        </Row>
        <Row
          style={{
            padding: 25,
            marginTop: 0,
            marginBottom: 100,
            paddingTop: 0,
            height:1500
          }}
        >
          <Tabs className="dashboardTabs" style={{height:'100%'}} >
            <TabPane
              className={"ant-tabs-top-contenti"}
              tab="Overall Leaderboard"
              key="01"
            >
                <Skeleton active={loading} loading={loading}>

                {cpDashbaordData && cpDashbaordData.data && cpDashbaordData.data.Dashboard.length>0 ? <GenTableDB branch={this.props.userBranch} campus={this.props.userCampus} props={this.props} data={cpDashbaordData.data.Dashboard}/> :null}

                </Skeleton>
 
            </TabPane>
            <TabPane
              className={"ant-tabs-top-contenti"}
              tab={
                <span>
                  <img
                    style={{ width: 20, height: 20 }}
                    src="https://www.hackerrank.com/wp-content/uploads/2018/07/hackerrank-favicon.png"
                  ></img>{" "}
                  HackerRank
                </span>
              }
              key="2"
            >
 <Skeleton active={loading} loading={loading}>

{cpDashbaordData && cpDashbaordData.data && cpDashbaordData.data.hackerRank.length>0 ? <GenTableHR branch={this.props.userBranch} campus={this.props.userCampus} props={this.props} data={cpDashbaordData.data.hackerRank}/> :null}

</Skeleton>

            </TabPane>
            <TabPane
              className={"ant-tabs-top-contenti"}
              tab={
                <span>
                  <img
                    style={{ width: 20, height: 20 }}
                    src="https://static-fastly.hackerearth.com/static/hackerearth/images/logo/HE_identity.png"
                  ></img>{" "}
                  hackerEarth
                </span>
              }
              key="1"
            >

<Skeleton active={loading} loading={loading}>

{cpDashbaordData && cpDashbaordData.data && cpDashbaordData.data.hackerEarth.length>0 ? <GenTableHE branch={this.props.userBranch} campus={this.props.userCampus} props={this.props} data={cpDashbaordData.data.hackerEarth}/> :null}

</Skeleton>

            </TabPane>

            <TabPane
              className={"ant-tabs-top-contenti"}
              tab={
                <span>
                  <img
                    style={{ width: 20, height: 20 }}
                    src="https://www.geeksforgeeks.org/favicon.ico"
                  ></img>
                  GeeksForGeeks
    
                </span>
              }
              key="4"
            >

<Skeleton active={loading} loading={loading}>

{cpDashbaordData && cpDashbaordData.data && cpDashbaordData.data.geeksForGeeks.length>0 ? <GenTableGG branch={this.props.userBranch} campus={this.props.userCampus} props={this.props} data={cpDashbaordData.data.geeksForGeeks}/> :null}

</Skeleton>

            </TabPane>
          </Tabs>
        </Row>
      </>
    );
  }
}

const mapStateToProps = state => {
  
  return {
    cpDashbaordData: state.auth.cpLeaderBoardList,
    skeltonLoading: state.loading
  };
};

const mapDispachToProps = (dispatch, props) => ({
  loadCpDashbaord: () => {
    dispatch(loginActions.loadCPLeaderBoard());
  },
  onUnload: () =>
    dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(cpDashboard);
